export default {
  // Maintenance - Repair Management
  'repair.maintenance.headerTitle': 'Maintenance Order Management',
  'repair.maintenance.action.create': 'New Order',
  'repair.maintenance.action.batchDelete': 'Batch Delete',
  'repair.maintenance.action.startProcess': 'Start Processing',
  'repair.maintenance.action.complete': 'Complete',
  'repair.maintenance.action.manageProgress': 'Manage Progress',
  'repair.maintenance.action.view': 'View',
  'repair.maintenance.action.edit': 'Edit',
  'repair.maintenance.action.delete': 'Delete',
  'repair.maintenance.column.workOrderNo': 'Order No.',
  'repair.maintenance.column.repairType': 'Repair Type',
  'repair.maintenance.column.urgeCount': 'Urge Count',
  'repair.maintenance.column.repairImages': 'Repair Images',
  'repair.maintenance.column.title': 'Title',
  'repair.maintenance.column.description': 'Repair Description',
  'repair.maintenance.column.status': 'Order Status',
  'repair.maintenance.column.createdTime': 'Created Time',
  'repair.maintenance.column.action': 'Action',
  'repair.maintenance.confirm.batchDelete':
    'Are you sure to batch delete the selected orders?',
  'repair.maintenance.confirm.ok': 'OK',
  'repair.maintenance.confirm.cancel': 'Cancel',
  'repair.maintenance.message.getRepairTypeFailed':
    'Failed to get repair types',
  'repair.maintenance.message.getStatusFailed': 'Failed to get order status',
  'repair.maintenance.message.deleteSuccess': 'Deleted successfully',
  'repair.maintenance.message.deleteFailed': 'Failed to delete',
  'repair.maintenance.message.batchDeleteSuccess': 'Batch deleted successfully',
  'repair.maintenance.message.batchDeleteFailed': 'Failed to batch delete',
  'repair.maintenance.message.startProcessSuccess':
    'Order status changed to processing',
  'repair.maintenance.message.startProcessFailed': 'Failed to change status',
  'repair.maintenance.message.completeSuccess': 'Order completed',
  'repair.maintenance.message.completeFailed': 'Failed to complete order',
  'repair.maintenance.message.getProgressListFailed':
    'Failed to get progress list',
  'repair.maintenance.message.addProgressSuccess':
    'Progress added successfully',
  'repair.maintenance.message.addProgressFailed': 'Failed to add progress',
  'repair.maintenance.message.deleteProgressSuccess':
    'Progress deleted successfully',
  'repair.maintenance.message.deleteProgressFailed':
    'Failed to delete progress',

  // Maintenance Drawer - Start Process
  'repair.maintenance.drawer.startProcess.title': 'Start Processing Order',
  'repair.maintenance.drawer.startProcess.section.basic':
    'Order Basic Information',
  'repair.maintenance.drawer.startProcess.section.owner': 'Owner Information',
  'repair.maintenance.drawer.startProcess.section.repair': 'Repair Information',
  'repair.maintenance.drawer.startProcess.section.images': 'Repair Images',
  'repair.maintenance.drawer.startProcess.section.system': 'System Information',
  'repair.maintenance.drawer.startProcess.label.workOrderNo': 'Order No.',
  'repair.maintenance.drawer.startProcess.label.repairType': 'Repair Type',
  'repair.maintenance.drawer.startProcess.label.status': 'Order Status',
  'repair.maintenance.drawer.startProcess.label.urgeCount': 'Urge Count',
  'repair.maintenance.drawer.startProcess.label.ownerName': 'Owner Name',
  'repair.maintenance.drawer.startProcess.label.ownerPhone': 'Owner Phone',
  'repair.maintenance.drawer.startProcess.label.ownerEmail': 'Owner Email',
  'repair.maintenance.drawer.startProcess.label.title': 'Title',
  'repair.maintenance.drawer.startProcess.label.description': 'Description',
  'repair.maintenance.drawer.startProcess.label.createdTime': 'Created Time',
  'repair.maintenance.drawer.startProcess.label.updatedTime': 'Updated Time',
  'repair.maintenance.drawer.startProcess.label.remark': 'Remark',
  'repair.maintenance.drawer.startProcess.placeholder.remark':
    'Please enter processing remarks, including processing plan, estimated time, etc.',
  'repair.maintenance.drawer.startProcess.rule.remarkRequired':
    'Please enter processing remark',
  'repair.maintenance.drawer.startProcess.button.submit': 'Start Processing',
  'repair.maintenance.drawer.startProcess.button.cancel': 'Cancel',

  // Maintenance Drawer - Complete
  'repair.maintenance.drawer.complete.title': 'Complete Processing',
  'repair.maintenance.drawer.complete.section.basic': 'Order Basic Information',
  'repair.maintenance.drawer.complete.section.owner': 'Owner Information',
  'repair.maintenance.drawer.complete.section.repair': 'Repair Information',
  'repair.maintenance.drawer.complete.section.images': 'Repair Images',
  'repair.maintenance.drawer.complete.section.system': 'System Information',
  'repair.maintenance.drawer.complete.label.workOrderNo': 'Order No.',
  'repair.maintenance.drawer.complete.label.repairType': 'Repair Type',
  'repair.maintenance.drawer.complete.label.status': 'Order Status',
  'repair.maintenance.drawer.complete.label.urgeCount': 'Urge Count',
  'repair.maintenance.drawer.complete.label.ownerName': 'Owner Name',
  'repair.maintenance.drawer.complete.label.ownerPhone': 'Owner Phone',
  'repair.maintenance.drawer.complete.label.ownerEmail': 'Owner Email',
  'repair.maintenance.drawer.complete.label.title': 'Title',
  'repair.maintenance.drawer.complete.label.description': 'Description',
  'repair.maintenance.drawer.complete.label.createdTime': 'Created Time',
  'repair.maintenance.drawer.complete.label.updatedTime': 'Updated Time',
  'repair.maintenance.drawer.complete.label.remarks': 'Remarks',
  'repair.maintenance.drawer.complete.label.remark': 'Completion Remark',
  'repair.maintenance.drawer.complete.placeholder.remark':
    'Please enter completion remarks, including completion status, processing results, etc.',
  'repair.maintenance.drawer.complete.rule.remarkRequired':
    'Please enter completion remark',
  'repair.maintenance.drawer.complete.button.submit': 'Confirm Completion',
  'repair.maintenance.drawer.complete.button.cancel': 'Cancel',

  // Maintenance Drawer - Progress Management
  'repair.maintenance.drawer.progress.title': 'Order Progress Management',
  'repair.maintenance.drawer.progress.section.basic': 'Order Basic Information',
  'repair.maintenance.drawer.progress.section.progressList': 'Progress Records',
  'repair.maintenance.drawer.progress.section.addProgress': 'Add New Progress',
  'repair.maintenance.drawer.progress.label.workOrderNo': 'Order No.',
  'repair.maintenance.drawer.progress.label.repairType': 'Repair Type',
  'repair.maintenance.drawer.progress.label.status': 'Order Status',
  'repair.maintenance.drawer.progress.label.title': 'Title',
  'repair.maintenance.drawer.progress.label.progressContent':
    'Progress Content',
  'repair.maintenance.drawer.progress.placeholder.progressContent':
    'Please enter progress content',
  'repair.maintenance.drawer.progress.button.addProgress': 'Add Progress',
  'repair.maintenance.drawer.progress.button.delete': 'Delete',
  'repair.maintenance.drawer.progress.confirm.deleteProgress':
    'Are you sure to delete this progress?',
  'repair.maintenance.drawer.progress.empty': 'No progress records',
  'repair.maintenance.drawer.progress.label.newProgress':
    'New Progress Description',
  'repair.maintenance.drawer.progress.placeholder.newProgress':
    'Please enter the progress description for this processing',
  'repair.maintenance.drawer.progress.rule.progressRequired':
    'Please enter progress description',
  'repair.maintenance.drawer.progress.button.submit': 'Submit Progress',
  'repair.maintenance.drawer.progress.button.close': 'Close',

  // Maintenance Detail Modal
  'repair.maintenance.modal.detail.title': 'Order Details',
  'repair.maintenance.modal.detail.section.basic': 'Order Basic Information',
  'repair.maintenance.modal.detail.section.owner': 'Owner Information',
  'repair.maintenance.modal.detail.section.repair': 'Repair Information',
  'repair.maintenance.modal.detail.section.images': 'Repair Images',
  'repair.maintenance.modal.detail.section.system': 'System Information',
  'repair.maintenance.modal.detail.label.workOrderNo': 'Order No.',
  'repair.maintenance.modal.detail.label.repairType': 'Repair Type',
  'repair.maintenance.modal.detail.label.status': 'Order Status',
  'repair.maintenance.modal.detail.label.urgeCount': 'Urge Count',
  'repair.maintenance.modal.detail.label.ownerName': 'Owner Name',
  'repair.maintenance.modal.detail.label.ownerPhone': 'Owner Phone',
  'repair.maintenance.modal.detail.label.ownerEmail': 'Owner Email',
  'repair.maintenance.modal.detail.label.title': 'Title',
  'repair.maintenance.modal.detail.label.description': 'Description',
  'repair.maintenance.modal.detail.label.createdTime': 'Created Time',
  'repair.maintenance.modal.detail.label.updatedTime': 'Updated Time',
  'repair.maintenance.modal.detail.label.remarks': 'Remarks',

  // Maintenance Form
  'repair.maintenance.form.create.title': 'New Maintenance Order',
  'repair.maintenance.form.edit.title': 'Edit Maintenance Order',
  'repair.maintenance.form.label.workOrderNo': 'Order No.',
  'repair.maintenance.form.placeholder.workOrderNo':
    'Auto-generated (optional)',
  'repair.maintenance.form.tooltip.workOrderNo':
    'If not filled, the system will automatically generate an order number',
  'repair.maintenance.form.label.repairType': 'Repair Type',
  'repair.maintenance.form.placeholder.repairType': 'Please select repair type',
  'repair.maintenance.form.rule.repairTypeRequired':
    'Please select repair type',
  'repair.maintenance.form.label.title': 'Title',
  'repair.maintenance.form.placeholder.title': 'Please enter order title',
  'repair.maintenance.form.rule.titleRequired': 'Please enter order title',
  'repair.maintenance.form.rule.titleMaxLength':
    'Title cannot exceed 100 characters',
  'repair.maintenance.form.label.description': 'Repair Description',
  'repair.maintenance.form.placeholder.description':
    'Please describe the repair issue in detail',
  'repair.maintenance.form.label.ownerName': 'Owner Name',
  'repair.maintenance.form.placeholder.ownerName':
    'Please click the query button to select owner',
  'repair.maintenance.form.tooltip.ownerName':
    'Please click the query button on the right to select owner',
  'repair.maintenance.form.label.ownerPhone': 'Owner Phone',
  'repair.maintenance.form.placeholder.ownerPhone': 'Please enter owner phone',
  'repair.maintenance.form.label.repairImages': 'Repair Images',
  'repair.maintenance.form.button.selectOwner': 'Select Owner',
  'repair.maintenance.form.button.submit': 'Submit',
  'repair.maintenance.form.button.cancel': 'Cancel',

  // Owner Select Modal
  'repair.maintenance.ownerModal.title': 'Select Owner',
  'repair.maintenance.ownerModal.button.ok': 'OK',
  'repair.maintenance.ownerModal.button.cancel': 'Cancel',

  // Complaint - Complaint Management
  'repair.complaint.headerTitle': 'Complaint Management',
  'repair.complaint.action.create': 'New Complaint',
  'repair.complaint.action.batchDelete': 'Batch Delete',
  'repair.complaint.action.startProcess': 'Start Processing',
  'repair.complaint.action.complete': 'Complete',
  'repair.complaint.action.manageProgress': 'Manage Progress',
  'repair.complaint.action.view': 'View',
  'repair.complaint.action.edit': 'Edit',
  'repair.complaint.action.delete': 'Delete',
  'repair.complaint.column.complaintNo': 'Complaint No.',
  'repair.complaint.column.complaintType': 'Complaint Type',
  'repair.complaint.column.urgeCount': 'Urge Count',
  'repair.complaint.column.complaintImages': 'Complaint Images',
  'repair.complaint.column.title': 'Title',
  'repair.complaint.column.description': 'Complaint Description',
  'repair.complaint.column.status': 'Complaint Status',
  'repair.complaint.column.createdTime': 'Created Time',
  'repair.complaint.column.action': 'Action',
  'repair.complaint.confirm.batchDelete':
    'Are you sure to batch delete the selected complaint records?',
  'repair.complaint.confirm.ok': 'OK',
  'repair.complaint.confirm.cancel': 'Cancel',

  // Complaint Drawer - Start Process
  'repair.complaint.drawer.startProcess.title': 'Start Processing Complaint',
  'repair.complaint.drawer.startProcess.placeholder.remark':
    'Please enter processing remarks, including processing plan, estimated time, etc.',

  // Complaint Drawer - Complete
  'repair.complaint.drawer.complete.title': 'Complete Processing',
  'repair.complaint.drawer.complete.placeholder.remark':
    'Please enter completion remarks, including completion status, processing results, etc.',

  // Complaint Drawer - Progress Management
  'repair.complaint.drawer.progress.title': 'Complaint Progress Management',
  'repair.complaint.drawer.progress.placeholder.progressContent':
    'Please enter progress content',
  'repair.complaint.drawer.progress.placeholder.newProgress':
    'Please enter the progress description for this processing',
  'repair.complaint.drawer.progress.confirm.deleteProgress':
    'Are you sure to delete this progress?',

  // Complaint Detail Modal
  'repair.complaint.modal.detail.title': 'Complaint Details',

  // Complaint Form
  'repair.complaint.form.create.title': 'New Complaint Record',
  'repair.complaint.form.edit.title': 'Edit Complaint Record',
  'repair.complaint.form.label.complaintNo': 'Complaint No.',
  'repair.complaint.form.placeholder.complaintNo': 'Auto-generated (optional)',
  'repair.complaint.form.tooltip.complaintNo':
    'If not filled, the system will automatically generate a complaint number',
  'repair.complaint.form.label.complaintType': 'Complaint Type',
  'repair.complaint.form.placeholder.complaintType':
    'Please select complaint type',
  'repair.complaint.form.rule.complaintTypeRequired':
    'Please select complaint type',
  'repair.complaint.form.label.title': 'Title',
  'repair.complaint.form.placeholder.title': 'Please enter complaint title',
  'repair.complaint.form.rule.titleRequired': 'Please enter complaint title',
  'repair.complaint.form.rule.titleMaxLength':
    'Title cannot exceed 100 characters',
  'repair.complaint.form.label.description': 'Complaint Description',
  'repair.complaint.form.placeholder.description':
    'Please describe the complaint issue in detail',
  'repair.complaint.form.label.complainantName': 'Complainant Name',
  'repair.complaint.form.placeholder.complainantName':
    'Please click the query button to select complainant',
  'repair.complaint.form.tooltip.complainantName':
    'Please click the query button on the right to select complainant',
  'repair.complaint.form.label.complainantPhone': 'Complainant Phone',
  'repair.complaint.form.placeholder.complainantPhone':
    'Please enter complainant phone',
  'repair.complaint.form.label.complaintImages': 'Complaint Images',
  'repair.complaint.form.button.selectComplainant': 'Select Complainant',

  // Complainant Select Modal
  'repair.complaint.complainantModal.title': 'Select Complainant',
  'repair.maintenance.title': 'Maintenance Orders',
  'repair.complaint.title': 'Complaint Records',
};
